import api from "./api";

// Get messages timeline data for charts
export const getMessagesTimeline = async (period = "daily", range = 30) => {
  const response = await api.get(
    `/analytics/messages-timeline?period=${period}&range=${range}`
  );
  return response.data;
};

// Get usage statistics for current subscription
export const getUsageStats = async () => {
  const response = await api.get("/analytics/usage-stats");
  return response.data;
};

// Get message status breakdown (pie/donut chart)
export const getMessageStatusBreakdown = async () => {
  const response = await api.get("/analytics/status-breakdown");
  return response.data;
};
